module.exports = __webpack_public_path__ + "static/media/asia.284d749c.png";